// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessTransfer_wrapper__0X9cF","statusImg":"SuccessTransfer_statusImg__x9PPo","logo":"SuccessTransfer_logo__2l0Za"};